import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-earth-800 via-earth-700 to-earth-800 text-white">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-8">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/c3013058-1479-428a-9f90-d7b3de3d7f4d.png" 
              alt="NWA Gutter Guards" 
              className="h-12 mb-4"
            />
            <p className="text-base leading-relaxed text-gray-300 mb-6">
              <strong>Premium stone coated gutter guard installation</strong> serving Northwest Arkansas with excellence since 2015.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-12 h-12 flex items-center justify-center bg-accent-600 rounded-full hover:bg-accent-700 transition-colors touch-manipulation" aria-label="Facebook">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center bg-accent-600 rounded-full hover:bg-accent-700 transition-colors touch-manipulation" aria-label="Instagram">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center bg-accent-600 rounded-full hover:bg-accent-700 transition-colors touch-manipulation" aria-label="Google">
                <i className="ri-google-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 lg:mb-6">Services</h4>
            <ul className="space-y-3 text-base">
              <li><Link to="/services/gutter-guard-installation" className="text-gray-300 hover:text-accent-400 transition-colors inline-block py-1 touch-manipulation">Gutter Guard Installation</Link></li>
              <li><Link to="/services/stone-coated-gutter-cap" className="text-gray-300 hover:text-accent-400 transition-colors inline-block py-1 touch-manipulation">Stone Coated Gutter Cap</Link></li>
              <li><Link to="/services/gutter-guards" className="text-gray-300 hover:text-accent-400 transition-colors inline-block py-1 touch-manipulation">Premium Gutter Guards</Link></li>
              <li><Link to="/services/seamless-gutters" className="text-gray-300 hover:text-accent-400 transition-colors inline-block py-1 touch-manipulation">Seamless Gutters</Link></li>
              <li><Link to="/services/gutter-cleaning" className="text-gray-300 hover:text-accent-400 transition-colors inline-block py-1 touch-manipulation">Gutter Cleaning & Repair</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 lg:mb-6">Service Areas</h4>
            <ul className="space-y-2 text-base text-gray-300 leading-relaxed">
              <li><strong>Fayetteville, AR</strong></li>
              <li>Springdale, AR</li>
              <li>Rogers, AR</li>
              <li>Bentonville, AR</li>
              <li>Bella Vista, AR</li>
              <li>Siloam Springs, AR</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 lg:mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-phone-line text-accent-400 mr-3 mt-1 text-xl flex-shrink-0"></i>
                <div>
                  <a href="tel:479-337-7565" className="text-gray-300 hover:text-accent-400 transition-colors text-base font-medium touch-manipulation inline-block">
                    (479) 337-7565
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-accent-400 mr-3 mt-1 text-xl flex-shrink-0"></i>
                <div>
                  <a href="mailto:info@nwagutterguards.com" className="text-gray-300 hover:text-accent-400 transition-colors text-base break-all touch-manipulation inline-block">
                    info@nwagutterguards.com
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-accent-400 mr-3 mt-1 text-xl flex-shrink-0"></i>
                <div className="text-gray-300 text-base leading-relaxed">
                  Serving Northwest Arkansas<br />
                  Fayetteville, AR 72701
                </div>
              </li>
            </ul>
            
            {/* Mobile-Friendly CTA Button */}
            <div className="mt-6">
              <Link 
                to="/contact" 
                className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-3 bg-accent-600 hover:bg-accent-700 text-white font-semibold rounded-lg transition-all touch-manipulation min-h-[48px] shadow-lg"
              >
                <i className="ri-message-3-line mr-2"></i> Get Free Quote
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p className="text-center md:text-left">&copy; 2025 NWA Gutter Guards. All rights reserved.</p>
          <div className="flex flex-wrap justify-center items-center gap-3">
            <Link to="/privacy-policy" className="hover:text-accent-400 transition-colors touch-manipulation py-2">Privacy Policy</Link>
            <span className="hidden sm:inline">|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-accent-400 transition-colors touch-manipulation py-2">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
